import type { ComponentProps } from "react";
import * as SelectPrimitive from "@radix-ui/react-select";

export type SelectGroupProps = ComponentProps<typeof SelectPrimitive.Group>;

export const SelectGroup = (props: SelectGroupProps) => (
  <SelectPrimitive.Group data-slot="select-group" {...props} />
);
